<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesRecordResultOverviewGreenlights",
  });

  const props = defineProps({
    checks: {
      type: Array,
      required: true,
    },
  });

  const filteredChecks = computed(() => {
    return props.checks.filter((check) => {
      return check.claims.length > 0;
    });
  });
</script>

<template>
  <div class="border-1 border-mcgreen p-2 text-mcgreen-700" :data-test="getTestId('greenlight')">
    <div
      class="-mx-2 -mt-2 flex cursor-default items-center space-x-2 border-b-1 border-mcgreen bg-mcgreen-100 px-2 py-3"
    >
      <ComponentIcon class="text-xl">tag_faces</ComponentIcon>
      <h3 class="inline font-semibold">Ohne Befund</h3>
      <span class="font-light">(Greenlight Check):</span>
    </div>

    <ul class="mt-2 space-y-2 print:break-before-avoid-page">
      <li
        v-for="(check, index) in filteredChecks"
        :key="check.id"
        class="flex cursor-help items-start space-x-2"
        :data-test="getTestId(`greenlight-${index}`)"
      >
        <ComponentIcon class="mt-0.5 text-xl">check_circle_outline</ComponentIcon>

        <MedTooltip :content="check.claims[0].description">
          <div>{{ check.claims[0].claim }}</div>
          <pre v-if="!check.claims[0].claim">{{ check }}</pre>
        </MedTooltip>
      </li>

      <li v-if="checks.length === 0" :data-test="getTestId('greenlight-empty')">
        Es wurden keine Ergebnisse „ohne Befund“ ermittelt.
      </li>
    </ul>
  </div>
</template>
